/**
 * IconButton
 * provide link and ask user to provide token from Trello
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';

const StyledButton = styled(Button)`
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #777777;
  opacity: 0.65;
  border: 0;
  background: transparent;
  &:hover {
    background: transparent;
    opacity: 1; 
  }
  &.pull-right {
    margin-right: -12px;
  }
`;

function IconButton({ icon, ...rest }) {
  return <StyledButton {...rest}><i className={`icon-${icon}`} /></StyledButton>;
}

IconButton.propTypes = {
  icon: PropTypes.string,
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/IconButton.js